// normalize для antd Form.Item: только цифры, не длиннее maxLength.
// Замена react-input-mask — его render-колбэк не пробрасывает маску в antd Input
export const normalizeDigits =
  (maxLength: number) =>
    (value?: string | number): string =>
      String(value ?? '')
        .replace(/\D/g, '')
        .slice(0, maxLength)
